import { QuestionError } from '@sm/question-definitions';
import { ErrorType } from './constants';
import { SurveyError } from './types';

function transformFromSurveyErrors<T extends QuestionError>(errors: SurveyError[]): T[] {
  return errors.map(
    ({ questionId, detail, code }: SurveyError) =>
      ({
        questionId,
        detail,
        // defaults to "TEXT_LENGTH", presently no way of knowing (consider adding UNKNOWN to SMQ)
        type: code === ErrorType.MISSING_REQUIRED_FIELD ? 'REQUIRED' : 'TEXT_LENGTH',
      } as T)
  );
}

export default transformFromSurveyErrors;
